// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar .nav-item-main,
.sidebar .nav-group-main {
  font-weight: 600 !important;
  font-size: 16px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 4px;
}

.sidebar .nav-item-main .nav-link,
.sidebar .nav-group-main > .nav-link {
  padding: 12px 16px !important;
  background: transparent !important;
  border-radius: 8px !important;
  margin-bottom: 8px !important;
  transition: all 1.3s ease !important;
  border: none !important;
}

.sidebar .nav-item-main .nav-link:hover,
.sidebar .nav-group-main > .nav-link:hover {
  background: rgba(0, 123, 255, 0.1) !important;
  color: #007bff !important;
  transform: translateX(4px);
}

.sidebar .nav-item-main .nav-link.active,
.sidebar .nav-group-main > .nav-link.active,
.sidebar .nav-group-main.show > .nav-link {
  color: #ffffff !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  transform: translateX(2px);
}

.sidebar .nav-item-main .nav-link.active:hover,
.sidebar .nav-group-main > .nav-link.active:hover,
.sidebar .nav-group-main.show > .nav-link:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important;
  transform: translateX(4px);
}

.nav-item-sub {
  font-weight: 400;
  font-size: 14px;
  margin-left: 16px;
}

.nav-item-sub .nav-link {
  padding: 8px 12px;
  color: #6c757d;
  background: rgba(0, 0, 0, 0.02);
  border-left: 3px solid transparent;
  border-radius: 4px;
  margin: 2px 0;
  transition: all 0.2s ease;
}

.nav-item-sub .nav-link:hover {
  color: #495057;
  background: rgba(0, 123, 255, 0.1);
  border-left-color: #007bff;
  transform: translateX(2px);
}

.nav-item-sub .nav-link.active {
  color: #007bff;
  background: rgba(0, 123, 255, 0.15);
  border-left-color: #007bff;
  font-weight: 500;
}

.nav-icon-main {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  color: #ffffff;
}

.nav-icon-sub {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  color: #6c757d;
  opacity: 0.7;
}

.nav-item-sub:hover .nav-icon-sub {
  color: #007bff;
  opacity: 1;
}

.nav-group-main .nav-group-items {
  padding-top: 8px;
  padding-bottom: 8px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 0 0 8px 8px;
  margin-top: -8px;
}

@media (max-width: 768px) {
  .nav-item-main,
  .nav-group-main {
    font-size: 15px;
  }
  .nav-item-sub {
    font-size: 13px;
    margin-left: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/_nav.scss"],"names":[],"mappings":"AAAA;;EAEE,2BAAA;EACA,0BAAA;EACA,iDAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,6BAAA;EACA,kCAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;EACA,uBAAA;AACF;;AAEA;;EAEE,6CAAA;EACA,yBAAA;EACA,0BAAA;AACF;;AAEA;;;EAGE,yBAAA;EACA,wEAAA;EACA,0BAAA;AACF;;AAEA;;;EAGE,wEAAA;EACA,0BAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,+BAAA;EACA,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,cAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;AACF;;AAEA;EACE,cAAA;EACA,mCAAA;EACA,0BAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,UAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,+BAAA;EACA,0BAAA;EACA,gBAAA;AACF;;AAEA;EACE;;IAEE,eAAA;EACF;EAEA;IACE,eAAA;IACA,iBAAA;EAAF;AACF","sourcesContent":[".sidebar .nav-item-main,\n.sidebar .nav-group-main {\n  font-weight: 600 !important;\n  font-size: 16px !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  margin-bottom: 4px;\n}\n\n.sidebar .nav-item-main .nav-link,\n.sidebar .nav-group-main > .nav-link {\n  padding: 12px 16px !important;\n  background: transparent !important;\n  border-radius: 8px !important;\n  margin-bottom: 8px !important;\n  transition: all 1.3s ease !important;\n  border: none !important;\n}\n\n.sidebar .nav-item-main .nav-link:hover,\n.sidebar .nav-group-main > .nav-link:hover {\n  background: rgba(0, 123, 255, 0.1) !important;\n  color: #007bff !important;\n  transform: translateX(4px);\n}\n\n.sidebar .nav-item-main .nav-link.active,\n.sidebar .nav-group-main > .nav-link.active,\n.sidebar .nav-group-main.show > .nav-link {\n  color: #ffffff !important;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n  transform: translateX(2px);\n}\n\n.sidebar .nav-item-main .nav-link.active:hover,\n.sidebar .nav-group-main > .nav-link.active:hover,\n.sidebar .nav-group-main.show > .nav-link:hover {\n  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important;\n  transform: translateX(4px);\n}\n\n.nav-item-sub {\n  font-weight: 400;\n  font-size: 14px;\n  margin-left: 16px;\n}\n\n.nav-item-sub .nav-link {\n  padding: 8px 12px;\n  color: #6c757d;\n  background: rgba(0, 0, 0, 0.02);\n  border-left: 3px solid transparent;\n  border-radius: 4px;\n  margin: 2px 0;\n  transition: all 0.2s ease;\n}\n\n.nav-item-sub .nav-link:hover {\n  color: #495057;\n  background: rgba(0, 123, 255, 0.1);\n  border-left-color: #007bff;\n  transform: translateX(2px);\n}\n\n.nav-item-sub .nav-link.active {\n  color: #007bff;\n  background: rgba(0, 123, 255, 0.15);\n  border-left-color: #007bff;\n  font-weight: 500;\n}\n\n.nav-icon-main {\n  width: 20px;\n  height: 20px;\n  margin-right: 12px;\n  color: #ffffff;\n}\n\n.nav-icon-sub {\n  width: 16px;\n  height: 16px;\n  margin-right: 10px;\n  color: #6c757d;\n  opacity: 0.7;\n}\n\n.nav-item-sub:hover .nav-icon-sub {\n  color: #007bff;\n  opacity: 1;\n}\n\n.nav-group-main .nav-group-items {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  background: rgba(0, 0, 0, 0.02);\n  border-radius: 0 0 8px 8px;\n  margin-top: -8px;\n}\n\n@media (max-width: 768px) {\n  .nav-item-main,\n  .nav-group-main {\n    font-size: 15px;\n  }\n  \n  .nav-item-sub {\n    font-size: 13px;\n    margin-left: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
